import React, { Component } from 'react';
import * as mat from 'material-ui';
import { connect } from 'react-redux';
import dummy from '../images/Logo.jpg';
import qLogo from '../images/Q.png';
// import FaEdit from 'react-icons/lib/fa/edit';
// import FaShareAlt from 'react-icons/lib/fa/share-alt';
// import FaTrash from 'react-icons/lib/fa/trash'
// import correct from '../images/Tick_Mark-256.png'
// import wrong from '../images/being-wrong.png'
// import { DeleteQuiz, EditMageQuiz, SahrePublicQuiz } from '../..//actions/editMage';

class JumbleDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            // open: false,
            key: ''
        }
    }
    // DeleteConfirm() {
    //     // this.props.DeleteQuiz(this.state.key)
    //     this.setState({ open: false });
    // }
    // Delete(keys) {
    //     this.setState({ key: keys })
    //     this.setState({ open: true });
    // }
    // Edit(keys) {
    //     this.props.EditMageQuiz(keys)
    // }
    // Share(keys) {
    //     this.props.SahrePublicQuiz(keys)
    // }
    // handleClose = () => {
    //     this.setState({ open: false });
    // };
    render() {
        // const actions = [
        //     <mat.FlatButton
        //         label="Cancel"
        //         primary={true}
        //         onClick={this.handleClose}
        //     />,
        //     <mat.FlatButton
        //         label="Delete"
        //         primary={true}
        //         keyboardFocused={true}
        //         onClick={this.DeleteConfirm.bind(this)}
        //     />,
        // ];
        const {
            Questions,
            jumbleData,
            lengths
        } = this.props;
        let AllQuestions = Object.keys(Questions).map((key, index) => {
            let val = Questions[key];
            //  lengths = key.length;

            return (
                <mat.Card key={index} zDepth={1} style={{ marginTop: '2%', overflow: 'hidden' }}>

                    <mat.CardHeader
                        title={val.questions}
                        subtitle={<span>{val.time}</span>}
                        subtitleStyle={{ color: 'gray' }}
                        actAsExpander={true}
                        showExpandableButton={true}
                        titleStyle={{ fontSize: '1.2em' }}
                        avatar={<mat.Avatar
                            src={val.imgUrl === 'https' ? val.imgUrl = qLogo : val.imgUrl}
                            size={70}
                        />}

                    />
                    <mat.CardText expandable={true}>
                        <mat.List>
                        <mat.ListItem
                                primaryText={val.answer1.value}
                                leftIcon={<p style={{ marginTop: '2.7%', color: 'gray' }}>A :</p>}
                                rightIcon={<span style={{ color: 'green', fontWeight: 'bold' }}>{val.correctSequence.indexOf(val.answer1.value) + 1}</span>}
                            />
                            <mat.ListItem
                                primaryText={val.answer2.value}
                                leftIcon={<p style={{ marginTop: '2.7%', color: 'gray' }}>B :</p>}
                                rightIcon={<span style={{ color: 'green', fontWeight: 'bold' }}>{val.correctSequence.indexOf(val.answer2.value) + 1}</span>}
                            />
                            <mat.ListItem
                                primaryText={val.answer3.value}
                                leftIcon={<p style={{ marginTop: '2.7%', color: 'gray' }}>C :</p>}
                                rightIcon={<span style={{ color: 'green', fontWeight: 'bold' }}>{val.correctSequence.indexOf(val.answer3.value) + 1}</span>}
                            />
                            <mat.ListItem
                                primaryText={val.answer4.value}
                                leftIcon={<p style={{ marginTop: '2.7%', color: 'gray' }}>D :</p>}
                                rightIcon={<span style={{ color: 'green', fontWeight: 'bold' }}>{val.correctSequence.indexOf(val.answer4.value) + 1}</span>}
                            />
                        </mat.List>
                    </mat.CardText>
                </mat.Card>
            )
        }
        )
        return (
            <div>
                <div className='container-flux'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <mat.Card style={{ overflow: 'hidden' }}>
                                <mat.CardMedia>
                                    <img style={{ width: '100%', height: 300 }} alt='img' src={jumbleData.imgUrl === 'https' ? jumbleData.imgUrl = dummy : jumbleData.imgUrl} />
                                </mat.CardMedia>
                                <mat.CardHeader
                                    title={jumbleData.titles}
                                    titleStyle={{ fontSize: '1.3em' }}
                                    subtitle={jumbleData.description}
                                    subtitleStyle={{ color: 'gray' }}
                                />
                                <mat.List>
                                    <mat.ListItem
                                        primaryText={jumbleData.type}
                                    />
                                </mat.List>
                                <mat.Card zDepth={0} className='text-right'>
                                    <mat.FlatButton
                                        label={<span>plays (0)</span>}
                                    />
                                    <mat.FlatButton
                                        label='Played'
                                        // onClick={this.Played.bind(this)}
                                    />
                                </mat.Card>
                                {/* <mat.Card zDepth={0}>
                                    <mat.FlatButton
                                        onClick={this.Delete.bind(this, jumbleData.titles)}
                                        label='Delete'
                                        icon={<FaTrash style={{ fontSize: '1.2em', color: '#999999' }} />}
                                    />
                                    <mat.FlatButton
                                        onClick={this.Edit.bind(this, jumbleData.titles)}
                                        label='Edit'
                                        icon={<FaEdit style={{ fontSize: '1.2em', color: '#999999' }} />}
                                    />
                                    <mat.FlatButton
                                        onClick={this.Share.bind(this, jumbleData.titles)}
                                        label='Share'
                                        icon={<FaShareAlt style={{ fontSize: '1.2em', color: '#999999' }} />}
                                    />
                                </mat.Card> */}
                            </mat.Card>
                        </div>
                        <div className='col-md-8'>
                            <div className='col-md-8 col-md-offset-2' style={{ marginTop: '4%' }}>
                                <h4>Questions ({lengths})</h4>
                                {AllQuestions}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <mat.Dialog
                    title="Warning..!"
                    actions={actions}
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.handleClose}
                >
                    <h3 style={{ color: 'red' }}>Are you ready for Delete Quiz with All Questions..!</h3>
                </mat.Dialog> */}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        jumbleData: state.DetailReducers.selectedQuiz,
        Questions: state.DetailReducers.QuizQuestions,
        lengths: state.DetailReducers.qLength,
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        // DeleteQuiz: (action) => {
        //     dispatch(DeleteQuiz(action))
        // },
        // EditMageQuiz: (action) => {
        //     dispatch(EditMageQuiz(action))
        // },
        // SahrePublicQuiz: (action) => {
        //     dispatch(SahrePublicQuiz(action))
        // },
        // DetailsQuiz: (action) => {
        //     dispatch(DetailsQuiz(action))
        // }
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(JumbleDetails);
// export default QuizDetails


// WEBPACK FOOTER //
// ./src/component/details/jumbleDetails.jsx